import CloudinaryImage from "@/components/cloudinary-image";

import { ClearIcon } from "./icons";
import type { UserType } from "./types";

interface UserProps {
  onToggle(user: UserType): void;
  readonly: boolean;
  user: UserType;
}

function User({ onToggle, readonly, user }: UserProps) {
  const handleClick = () => onToggle(user);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: its fine
    // biome-ignore lint/a11y/useKeyWithClickEvents: its fine
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: legacy
    <div className="relative shrink-0 cursor-pointer" onClick={handleClick}>
      <CloudinaryImage
        className="size-10 rounded-full"
        rW={80}
        size={40}
        user={user}
      />
      {!readonly && (
        <div className="absolute -top-1 -right-1 flex size-4.5 items-center justify-center rounded-full border border-white/20 bg-gunmetal text-center">
          <ClearIcon />
        </div>
      )}
    </div>
  );
}

interface SelectedUsersProps {
  onToggle(user: UserType): void;
  readonlyUsers: string[];
  users: UserType[];
}

export default function SelectedUsers({
  onToggle,
  readonlyUsers,
  users,
}: SelectedUsersProps) {
  return (
    <div className="ml-5 flex items-center gap-2.5">
      {users.map((user) => (
        <User
          key={user.id}
          onToggle={onToggle}
          readonly={readonlyUsers.includes(user.id)}
          user={user}
        />
      ))}
    </div>
  );
}
